let TENANT = '';
let REGISTRY_URL = '';

export const getPlatformId = () => {
  if (!TENANT || !REGISTRY_URL) {
    const values = getServicesFromFile();
    TENANT = values.tenant;
    REGISTRY_URL = values.registryUrl;
  }

  return TENANT;
};

export const getRegistryUrl = () => {
  if (!TENANT || !REGISTRY_URL) {
    const values = getServicesFromFile();
    TENANT = values.tenant;
    REGISTRY_URL = values.registryUrl;
  }

  return REGISTRY_URL;
};

export const getServicesFromFile = () => window.mpp;
